import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import messageReducer from "./slices/messageSlice";
import themeReducer from "./slices/themeSlice";
import loaderReducer from "./slices/loaderSlice";
import onBoardingReducer from "./slices/onBoardingSlice";
import accountReducer from "./slices/accountSlice";
import verificationReducer from "./slices/verificationSlice";
import battleReducer from "./slices/battleSlice";
import paymentReducer from "./slices/paymentSlice";
import cartReducer from "./slices/cartSlice";
import boxReducer from "./slices/boxSlice";
const reducer = {
  auth: authReducer,
  cart: cartReducer,
  theme: themeReducer,
  loader: loaderReducer,
  battle: battleReducer,
  message: messageReducer,
  account: accountReducer,
  payment: paymentReducer,
  onboarding: onBoardingReducer,
  verification: verificationReducer,
  box: boxReducer, 
};

export const store = configureStore({
  reducer: reducer,
  devTools: true,
});
